import { boldFont, screenSize } from '@app/styles';
import styled from 'styled-components';

export const Container = styled.div`
  @media (${screenSize.tablet}) {
    padding: 24px 24px 24px 40px;
  }
`;
export const Header = styled.div``;
export const HeaderSection = styled.div``;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
`;
export const TableHead = styled.thead``;

export const TabledBody = styled.tbody``;

export const TableRow = styled.tr`
  background: #3c8ec5;
`;
export const TableDataRow = styled.tr`
  border-bottom: 1px solid #d1d1d1;
`;
export const TableHeader = styled.th`
  padding: 8px;
  color: #ffffff;
`;

export const Module = styled.td`
  width: 20%;
  padding: 8px;
  ${boldFont}
  font-size: 14px;
  line-height: 30px;
  color: #080707;
`;
export const Description = styled.td`
  width: 40%;
  padding: 8px;
  font-size: 14px;
  line-height: 30px;
  color: #080707;
`;
export const UserName = styled.td`
  width: 20%;
  padding: 8px;
  ${boldFont}
  font-size: 14px;
  line-height: 18px;
  color: #080707;
`;
export const TimeStamp = styled.td`
  width: 20%;
  padding: 8px;
  font-size: 14px;
  line-height: 30px;
  color: #42526e;
`;

export const ActivityLogDIv = styled.div`
  border: 1px solid #ccc;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 8px;
`;
export const UserContainer = styled.div`
  margin-bottom: 8px;
`;
export const ModuleContainer = styled.div`
  margin-bottom: 8px;
`;
export const DescriptionContainer = styled.div``;
export const Label = styled.div`
  font-size: 14px;
  color: #3b4049;
  opacity: 0.5;
  line-height: 30px;
  font-weight: 700;
`;
export const Value = styled.div`
  font-size: 16px;
  color: #3b4049;
  line-height: 30px;
  font-weight: 700;
`;
export const ActivityTimeStamp = styled.div`
  font-size: 15px;
  color: #3b4049;
  opacity: 0.2;
  text-align: end;
  line-height: 30px;
  font-weight: 700;
`;
